import React, { Component } from 'react';
import { array, bool } from 'prop-types';
import { Grid } from '@ycos/component-grid';
import { withTheme, ThemeProvider } from '@ycos/fela'
import SpanContainer from './SpanContainer';

class TwoColumnItemList extends Component {
  static layoutVariant = ['isc-2-column-item-list'];

  render() {
    const children = Array.isArray(this.props.children) ? this.props.children : [this.props.children];

    return (
      <ThemeProvider theme={{...this.props.theme, direction: 'ltr'}}>
        <Grid.Row verticallyCenter={this.props.verticallyCenter}>
          {children.map((child, idx) => {
            return (
              <Grid.Span
                key={child.key}
                small={{ offset: 0, width: 6 }}
                medium={{ offset: (idx % 2) ? 0 : 1, width: 5 }}
              >
                <SpanContainer>
                  <ThemeProvider theme={this.props.theme}>
                    {child}
                  </ThemeProvider>
                </SpanContainer>
              </Grid.Span>
            );
          })}
        </Grid.Row>
      </ThemeProvider>
    );
  }
}

TwoColumnItemList.propTypes = {
  children: array,
  verticallyCenter: bool
};

TwoColumnItemList.defaultProps = {
  children: []
};

export default withTheme(TwoColumnItemList);
